import React, { useEffect } from "react";
import { DialogBar } from "../../../components/common/DialogBar";
import { useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export const Team2SubtopicOne = () => {
	const { loaded } = useSelector((state) => state.menu);
	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.team2.introduction, 0);
		}
	}, [loaded]);
	return (
		<>
			<DialogBar callback={() => {}} dialog={"Bienvenido subtema 1"} percentage={"100%"}></DialogBar>
		</>
	);
};
